import { GET_SEARCH_UF } from 'govbr.frontend.policy/constants/ActionTypes';

const initialState = {
  loading: false,
  loaded: false,
  error: null,
  items: [],
  total: 0,
  page_size: 30,
  page: 1,
};

const getItemUrl = (item) => {
  const nestedUrl = item?.dados_noticia?.[0]?.url_noticia;
  return nestedUrl || item?.contentUrl || item?.url || item?.['@id'] || null;
};

const normalizeItems = (items) => {
  return items.map((item) => {
    const itemUrl = getItemUrl(item);
    return {
      '@type': 'News Item',
      '@id': itemUrl,
      url: itemUrl,
      href: itemUrl,
      title: item.title,
      subtitle: item.dados_noticia?.[0]?.subtitulo,
      category_title: item.dados_noticia?.[0]?.categoria,
      image_url: item.dados_noticia?.[0]?.path_imagem_noticia,
      uf_noticia: item['type'] === 'News Item' ? item.uf_noticia : undefined,
      Subject: item.tags,
      description: item.description,
      EffectiveDate: item.effectiveAt,
    };
  });
};

export default function search_uf(state = initialState, action = {}) {
  switch (action.type) {
    case `${GET_SEARCH_UF}_PENDING`:
      return {
        ...state,
        loading: true,
        loaded: false,
        error: null,
      };

    case `${GET_SEARCH_UF}_SUCCESS`:
      return {
        ...state,
        loading: false,
        loaded: true,
        ...action.result,
        items: normalizeItems(action.result.items || []),
      };

    case `${GET_SEARCH_UF}_FAIL`:
      return {
        ...state,
        loading: false,
        loaded: true,
        items: [],
        total: 0,
        error: action.error,
      };

    default:
      return state;
  }
}
